import { z } from 'zod';

export const shippingTypeSchema = z.object({
  shippingTypeId: z.coerce
    .number({
      error: 'Bitte wählen Sie eine Versandart aus',
    })
    .min(1, {
      message: 'Bitte wählen Sie eine Versandart aus',
    }),
});
